import axios from "axios";
import moment from "moment";
import { constants } from "../Helpers/Constants";
import i18n from '../i18n';

export function setUserSession(user_data) {
    return function(dispatch) {
        dispatch({type: "SET_SESSION", payload: user_data})
    }
}   

export function checkAuthenticated() {
    return function(dispatch) {
        axios.post('/ajax/authenticated')
        .then(function(response) {
            if (response?.data.success) {
                if (response?.data.user.language !== "English" && response?.data.user.user_type === constants.user_type.user) {
                    i18n.changeLanguage('fr')
                    //moment.locale('fr');
                }

                let user_data = response?.data.user;
                let vmhs = [];
                let shs = [];
                user_data.profile_access.active_sh_vmh_access.forEach((access) => {
                    let vmh_index = vmhs.findIndex(obj => obj['VMH_ID'] == access.VMH_ID);
                    if (vmh_index !== -1 && vmhs[vmh_index]) {
                        let temp = vmhs[vmh_index];
                        if(!temp.SH_ID.includes(access.SH_ID)) {
                            temp.SH_ID.push(access.SH_ID);
                            vmhs[vmh_index] = temp;
                        }
                    }
                    else {
                        let obj = {VMH_ID: access.VMH_ID, SH_ID: [access.SH_ID]}
                        vmhs.push(obj);
                    }
                    let sh_index = shs.findIndex(obj => obj['stakeholderId'] == access.SH_ID);
                    if (sh_index !== -1 && shs[sh_index]) {
                        let temp = shs[sh_index];
                        if(!temp.vehicleCenterIds.includes(access.VMH_ID)) {
                            temp.vehicleCenterIds.push(access.VMH_ID);
                            shs[sh_index] = temp;
                        }
                    }
                    else {
                        let obj = {stakeholderId: access.SH_ID, vehicleCenterIds: [access.VMH_ID]}
                        shs.push(obj);
                    }
                })
                user_data['profile_access']['active_vmh_access'] = vmhs;
                user_data['profile_access']['active_sh_access'] = shs;

                dispatch({type: "SET_SESSION_OEM", payload: user_data})
                dispatch({type: "SET_OEM_SPECIFIC", payload: {
                    server_email_name: response?.data.oem_info.server_email_name,
                    login_logo: response?.data.oem_info.login_logo,
                    logo: response?.data.oem_info.logo,
                    nav_logo: response?.data.oem_info.nav_logo,
                    nav_logo_reversed: response?.data.oem_info.nav_logo_reversed,
                    application_success_logo: response?.data.oem_info.application_success_logo,
                    oem_success_logo: response?.data.oem_info.oem_success_logo,
                    oem_colour: response?.data.oem_info.oem_colour,
                    vehicle_type: response?.data.oem_info.vehicle_type,
                    vehicle_usage_types: response?.data.oem_info.vehicle_usage_types,
                    vehicle_options: response?.data.oem_info.vehicle_options,
                    vehicle_details: response?.data.oem_info.vehicle_details,
                    images: response?.data.oem_info.images
                }})
            }
        })
        .catch(function(error) {
            if(error.response?.status == 401){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                showStatusMsg("Requested information not found");
            }
        })
    }
}

export function destroyCredentials() {
    return function(dispatch) {
        dispatch({type: "DESTROY_SESSION"});
    }
}